<script>
    import axios from 'axios';

    export default {
        props: {
            id: String,
        },
        methods: {
            close() {
                this.$store.commit('closeModal');
            },
            async archive() {
                await axios.put(`/api/claims/${this.id}/archive`, {});
                this.close();
                location.reload();
            }
        }
    };
</script>

<template>
    <!--TODO FE: Teksten beheerbaar maken-->
    <header class="modal-card-head">
        <p class="modal-card-title">{{ $store.getters.getClaimDetailText('claimdetailModalTitleArchive') }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
    </header>
    <section class="modal-card-body">
        {{ $store.getters.getClaimDetailText('claimdetailModalContentArchive') }}
        <br>
        <i class="fa-regular fa-square-check"></i>
    </section>
    <footer class="modal-card-foot is-justify-content-end">
        <button class="button is-primary is-outlined" @click="close">{{ $store.getters.getClaimDetailText('claimdetailModalButtonCancel') }}</button>
        <button class="button is-primary" @click="archive">{{ $store.getters.getClaimDetailText('claimdetailModalButtonSave') }}</button>
    </footer>
</template>
